import type {Env} from '@hconnect/common/hproduce'
import {hproduce} from '@hconnect/common/hproduce/config/hproduce'
import {refraplanner} from '@hconnect/common/hproduce/config/refraplanner'
import {useEffect} from 'react'

export const PlantSelectorRedirect: React.FC = () => {
  const env = process.env.REACT_APP_STAGE as Env
  const HProduceEntryPointRedirectUrl = `${hproduce.url[env]}/${refraplanner.name}`

  useEffect(() => window.location.replace(HProduceEntryPointRedirectUrl))

  return null
}
